import { render, staticRenderFns } from "./addEmail.vue?vue&type=template&id=bb90bbe4&scoped=true"
import script from "./addEmail.vue?vue&type=script&lang=js"
export * from "./addEmail.vue?vue&type=script&lang=js"
import style0 from "./addEmail.vue?vue&type=style&index=0&id=bb90bbe4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb90bbe4",
  null
  
)

export default component.exports